// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SmartscapeSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SmartscapeSignetIcon" ref={forwardedRef} {...props}>
      <path d="M9.75 2.06a.56.56 0 0 1 .5 0l6.443 3.25A.56.56 0 0 1 17 5.807v8.384a.56.56 0 0 1-.307.499l-6.442 3.25a.56.56 0 0 1-.502 0l-6.442-3.25A.56.56 0 0 1 3 14.192V5.808A.56.56 0 0 1 3.307 5.31zm.724 2.218a1.367 1.367 0 0 0-1.278 1.85L6.524 8.343a1.367 1.367 0 1 0 .292 2.059l4.443 2.33a1.757 1.757 0 1 0 3.48.34 1.757 1.757 0 0 0-1.838-1.758l-1.625-4.562a1.367 1.367 0 0 0-.803-2.474M9.716 6.784a1.36 1.36 0 0 0 .758.23h.008l1.616 4.537a1.8 1.8 0 0 0-.486.42L7.151 9.633a1.36 1.36 0 0 0-.092-.646z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SmartscapeSignetIcon = /* @__PURE__ */ Object.assign(
  SmartscapeSignetIconComponent,
  { displayName: 'SmartscapeSignetIcon' },
);
